var map = {
	"./far1_active.png": "da85",
	"./far2_active.png": "ee09",
	"./far3_active.png": "042d",
	"./son1_active.png": "82a1",
	"./son2_active.png": "6686",
	"./third1_1_active.png": "f1a8",
	"./third1_2_active.png": "37da",
	"./third1_3_active.png": "f96f",
	"./third1_4_active.png": "eb83",
	"./third1_5_active.png": "c1a9",
	"./third1_6_active.png": "983c",
	"./third1_7_active.png": "2624",
	"./third1_8_active.png": "e8fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd16";